import { render, staticRenderFns } from "./dashChart.vue?vue&type=template&id=d8d9130a&"
import script from "./dashChart.vue?vue&type=script&lang=ts&"
export * from "./dashChart.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports